export default __webpack_public_path__ + "static/media/history_1980_01.c69f8b50.png";